import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link, useParams } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"
import moment from 'moment';
import DatePicker from "react-datepicker";

const GETDATABYID = "api/puja"
const EDITDATA = 'api/puja/update'
function EditPuja() {

    document.title = "Edit Puja- Jain Sadhana"
    const { id } = useParams()
    const [editabledata, Setalleditabledata] = useState([]);
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();

    const [showDate, setShowdate] = useState(false)

    const showSchedule = () => {
        setShowdate(!showDate)
        if (showDate === true) {
            Setalleditabledata({ ...editabledata, status: "published" })
        }
        else {
            Setalleditabledata({ ...editabledata, status: "scheduled" })
        }
    };


    useEffect(() => {
        const getdatabyid = async () => {
            try {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                Setalleditabledata(response?.data?.puja)
                if (response?.data?.puja?.status === "scheduled") {
                    setShowdate(true)
                }

            } catch (error) {
                console.log(error.response.data.message)

            }
        }
        getdatabyid();
    }, [])


    const HandleEdit = async (event) => {
        Setloading(true)
        event.preventDefault();
        try {
            const editdata = await axios.patch(`${EDITDATA}/${id}`, {
                englishtitle: editabledata.englishtitle,
                hindititle: editabledata.hindititle,
                content: editabledata.content,
                scheduledate: moment(editabledata?.scheduledate).format("YYYY-MM-DD"),
                status: editabledata?.status
            })
            if (editdata.status === 200) {
                navigate('/menu/pujalist')
                toast.success('Successfully Updated')
                Setloading(false)
            }
        } catch (error) {
            console.log(error.response.data.message)
            setTimeout(()=>Setloading(false),1000)
        }
    }





    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" puja="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black text-capitalize'  >Edit puja</p>
                                    <Link to="/menu/pujalist" className='text-black btn button-yellow  back-list-button text-capitalize'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All puja</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleEdit}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <label htmlFor="englishtitle" className='label-style'>Puja Title In English</label>
                                                            <input type="text" value={editabledata.englishtitle} onChange={(event) => Setalleditabledata({ ...editabledata, englishtitle: event.target.value })} className="form-control  bg-gray border border-0" id="englishtitle" name='englishtitle' placeholder="Puja English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <label htmlFor="hindititle" className='label-style'>Puja Title In Hindi</label>
                                                            <input type="text" value={editabledata.hindititle} onChange={(event) => Setalleditabledata({ ...editabledata, hindititle: event.target.value })} className="form-control  bg-gray border border-0" id="hindititle" name='hindititle' placeholder="Puja Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">

                                                        <div className="mb-3">
                                                            <label htmlFor="content" className='label-style'>Puja Content</label>
                                                            <textarea value={editabledata.content} onChange={(event) => Setalleditabledata({ ...editabledata, content: event.target.value })} style={{ height: "150px" }} className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Puja Content" required />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="align-items-center gap-2 mb-2 ">
                                                    <input type='checkbox' onClick={showSchedule} id='checkbox' checked={editabledata?.status === "scheduled"} />
                                                    <label className="label-style" htmlFor='checkbox'>Click on the Checkbox to Schedule</label>
                                                    {
                                                        showDate === true ? <div>
                                                            <label className="label-style d-block ms-4">Enter Schedule Date</label>
                                                            <DatePicker value={moment(editabledata?.scheduledate).format("YYYY-MM-DD")} selected={editabledata?.scheduledate ? moment(editabledata.scheduledate, 'YYYY-MM-DD').toDate() : null} minDate={new Date()} onChange={(date) => Setalleditabledata({ ...editabledata, scheduledate: date })} className="width50 form-control ms-4 border border-2 border-dark" />
                                                        </div> : ""
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/pujalist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditPuja